<template>
  <div class="homePage" >
    <!--<header class="header divflex">-->
      <!--&lt;!&ndash;<a href="index.html" class="backlastpage"></a>&ndash;&gt;-->
      <!--<h3>首页</h3>-->
    <!--</header>-->
     <div class="searchDiv">
       <!--<div>-->
         <div style="padding-top: 10px;padding-left: 14px">{{newTime}}</div>
       <!--</div>-->
       <div style="display: flex">
         <div class="search">
           <van-search
              v-model="name"
             shape="round"
             background="#6e9bcf"
             placeholder="请输入搜索关键词"
           v-on:input="getWrite"/>
         </div>
         <div class="searchIcon">
           <!--<van-popover v-model="showPopover" :actions="actions" @select="onSelect">-->
             <!--<template #reference>-->
               <!--<van-button type="primary" @click="showPopover = true">-->
                 <!--&lt;!&ndash;浅色风格&ndash;&gt;-->
               <!--</van-button>-->
               <!--&lt;!&ndash;<van-icon background="#6e9bcf" color="#FFFFFF" name="plus" />&ndash;&gt;-->
             <!--</template>-->
           <!--</van-popover>-->
           <van-popover background-color="#6e9bcf" v-model="showPopover" theme="dark"   :actions="actions" placement="bottom-end"  @select="onSelect">
             <template background-color="#6e9bcf" #reference >
               <!--<van-button type="primary" @click="showPopover = true">-->
                 <!--深色风格-->
               <!--</van-button>-->
               <van-icon  background-color="#6e9bcf" color="#FFFFFF" name="plus" @click="showPopover = true"  />
             </template>
           </van-popover>
         </div>
       </div>

     </div>
     <!--<div class="follow">-->
       <!--<div style="padding-top: 22px;margin-left: 13px">-->
         <!--<span>我关注的公司</span>-->
         <!--<span style="display: block;font-size: 10px;color: #BEBEBE">持续追踪公司动态</span>-->
       <!--</div>-->
       <!--<div style="display: flex;">-->
         <!--<div class="company">-->
           <!--<div><img style="width: 50px;height: 50px" src="@/assets/img/0.jpg" alt=""></div>-->
           <!--<span style="font-size: 10px">小田满茶</span>-->
         <!--</div>-->
         <!--<div class="company">-->
           <!--<div><img style="width: 50px;height: 50px" src="@/assets/img/1.jpg" alt=""></div>-->
           <!--<span style="font-size: 10px">小田满茶</span>-->
         <!--</div>-->
       <!--</div>-->
     <!--</div>-->
    <!--<div>-->
      <!--<img style="width: 100%;height: 9rem" src="@/assets/img/4.jpg" alt="">-->
    <!--</div>-->
    <div style="padding: 90px 0px">
      <!--<van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">-->
        <van-list
          v-model="isUpLoading"
          :finished="upFinished"
          :immediate-check="false"
          finished-text="我是有底线的"
          @load="onLoad">
      <div class="photoDiv" style="" v-for="(index,key) in list">
      <div class="photoTop">
        <div class="photoTopLeft">
          <div class="imgDiv">
            <img v-if="index.photo" class="imgSrc" :src="index.photo" alt="">
            <img v-else="" class="imgSrc" src="@/assets/img/tx.jpg" alt="">
          </div>
          <div class="photoTopRight">
            <span style="color:#6e9bcf;padding-left: 15px">{{index.name}}</span>
            <!--<span style="font-size: 1px;color:#BEBEBE ">37分钟前在线</span>-->
          </div>
        </div>
        <div v-if="index.userid!=homeId&&index.isfollow==0" class="clickFollow"  @click="followClick(index,1)" >+关注&nbsp;</div>
        <div v-if="index.userid!=homeId&&index.isfollow==1" class="clickFollow"  @click="followClick(index,2)" >已关注&nbsp;</div>
      </div>
      <div class="write" style="width: 100%;">
        <div >
        <!--<div v-for="(index,key) in list">-->
          <p class="word">{{index.word}}</p>
          <div class="writeImg"><!--说说-->
            <ul>
              <li v-for="(item, a) in index.img" :key=index >
                <img :src="item">
              </li>
            </ul>
          </div>
          <div class="iconDiv"><!--图标-->
            <div>
              <van-icon v-if="index.islike==1" @click="followLiker(index,2)" size="20px" color="red" name="like" />
              <van-icon v-if="index.islike!=1" @click="followLiker(index,1)" size="20px"class="borderColor"  name="like-o" />
              <!--<van-icon v-if="aaa.islike==1" @click="followLiker(index,2)" size="20px" color="red" name="like" />-->
              <!--<van-icon v-if="aaa.islike!=1" @click="followLiker(index,1)" size="20px"class="borderColor"  name="like-o" />-->
              <!--<van-icon size="20px" class="borderColor" name="chat-o" badge="9" @click="toDetail(index.id)"  />-->
              <!--<van-icon v-if="bool==true" @click="colorIcon" size="20px" color="red" name="like" />-->
              <!--<van-icon v-if="bool==false"  size="20px"class="borderColor" @click="colorIcon" name="like-o" />-->
              <van-icon size="20px" class="borderColor" style="margin-left: 10px" name="star-o" />
              <van-icon size="20px" class="borderColor" style="margin-left: 10px" name="share-o" />
            </div>

            <!--<van-icon size="30px" class="borderColor" name="other-pay" />-->
          </div>
          <div class="comment"  ><!--评论-->
            <div>
              <div  style="display: flex">
                <!--<div style="width: 40px;height: 40px;">-->
                  <!--<img style="width: 100%;height: 100%;border-radius: 100%" src="@/assets/img/tx.jpg" alt="">-->
                  <!--<span>小小</span>-->
                <!--</div>-->
                <div style="margin-left:10px;width: 100%  ">
                  <div v-if="index.comment" v-for="(a,b) in index.comment" @click="toDetail(index.id)">
                    <span>{{a.name}}:</span>
                    <span style="font-size: 1px;color:#BEBEBE " v-if="index.comment">{{a.comment}}</span>
                    <!--<span class="commentZhan"> <van-icon  size="20px"   name="good-job-o" /></span>-->
                  </div>
                  <!--<p style="display: flex;justify-content: space-between">-->
                    <!--<van-icon v-if="boolD==false" size="20px"  @click="colorIconD" name="good-job-o" />-->
                    <!--<van-icon v-else-if="boolD==true" size="20px"  @click="colorIconD" color="#6e9bcf" name="good-job" />-->
                  <!--</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
        </van-list>
      <!--</van-pull-refresh>-->
    <!--<div style="width: 80%;margin: auto;font-size: 13px">-->
    <!--<p>个人简历：看见对方开具收款的JFK收到JFK的数据库</p>-->
    <!--<div>-->
    <!--<div  style="display: flex">-->
    <!--<div style="width: 40px;height: 40px;">-->
    <!--<img style="width: 100%;height: 100%;border-radius: 100%" src="@/assets/img/tx.jpg" alt="">-->
    <!--&lt;!&ndash;<span>小小</span>&ndash;&gt;-->
    <!--</div>-->
    <!--<div style="margin-left:10px;width: 80%  ">-->
    <!--<p >小小</p>-->
    <!--<p style="display: flex;justify-content: space-between">评论评论评论 <van-icon size="20px" color="#6e9bcf" name="good-job" /></p>-->
    <!--</div>-->

    <!--&lt;!&ndash;<div><span>小小dsadsa </span></div>&ndash;&gt;-->
    <!--</div>-->
    <!--&lt;!&ndash;<p style="width: 70%;margin: auto" class="comment">评论</p>&ndash;&gt;-->
    <!--&lt;!&ndash;<div style="width: 50px;height: 50px" ><img style="width: 100%;height: 100%" src="@/assets/img/tx.jpg" alt=""></div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div style="width: 50px;height: 50px" ><img style="width: 100%;height: 100%" src="@/assets/img/tx.jpg" alt=""></div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div style="width: 50px;height: 50px" ><img style="width: 100%;height: 100%" src="@/assets/img/tx.jpg" alt=""></div>&ndash;&gt;-->
    <!--</div>-->
    <!--</div>-->
    </div>
    <van-tabbar route >
      <van-tabbar-item replace to="/home" icon="wap-home-o">
        商城
      </van-tabbar-item>
      <van-tabbar-item replace to="/" icon="wap-home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/position" icon="envelop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace @click="href()" icon="fire-o">
        <!--<van-icon name="fire-o" />-->
        社保
      </van-tabbar-item>
      <van-tabbar-item replace to="/firstMessage" icon="desktop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/HelloWorld" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
 import  popover  from 'vant';
 const days = ['天', '一', '二', '三', '四', '五', '六']; // 星期数组
 var icnow = new Date();      // 初始化时间
 var interval;
  export default {
    name: 'homePage',
    data () {
      return {
        firstName: 'Fo',
        lastName: 'Bar',
        msg: '',
        name:'',
        showPopover: false,
        actions: [{ text: '拍摄' }, { text: '相册' }, { text: '写一写' }],
//        list:[],
        listData:[],
        arry:[],
        arr:{islike:''},
        islike:'',
        bool:false,
        boolD:false,
        boolG:false,
        isDownLoading:false,
        isUpLoading:false,
        upFinished:false,
        pageIndex:1,
        pageSize:10,
        homeId:localStorage.getItem("userid"),
        year: icnow.getFullYear(),
        month: icnow.getMonth() + 1,
        date: icnow.getDate(),
        day: days[icnow.getDay() - 1],
        time: icnow.toTimeString().substring(0, 8),
        data:[]
      }
    },
    created () {
      interval = setInterval(() =>{
        let icnow = new Date();
        this.year = icnow.getFullYear();
        this.month = icnow.getMonth() + 1;
        this.date = icnow.getDate();
        this.day = days[icnow.getDay()];
        this.time = icnow.toTimeString().substring(0, 8);
      }, 1000)
    },
    mounted(){
      this.getWrite()
//      this.followClick()
    },
    computed: {
      // 当前时间
      newTime: function () {
//        return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
        return this.month + '月' + this.date + '日' + this.time;
      },
      list: function () {
//        return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
//        return this.islike
        return this.listData
      },
      aaa: function () {
//        return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
        console.log(this.islike)
        return this.arr
//        return this.arry=this.listData
      },
      fullName: function () {
        return this.firstName + ' ' + this.lastName
      }
    },
    beforeDestroy () {
      clearInterval(interval);
    },

    methods: {
      colorIcon(){
        this.bool=!this.bool
      },
      colorIconD(){
        this.boolD=!this.boolD
      },
      colorIconG(){
        this.boolG=!this.boolG
      },
      href(){
        window.location.href = 'https://m.shangshebao.com';
      },
      onSelect(action) {
        if(action.text=="写一写"){
          this.$router.push("/writer")
        }
      },
      toDetail(index){
        this.$router.push({
          path:'/homePageDetail',
          query:{
            id:index
          }
        })
      },
      getWrite(){
        this.$api.getWrite(
          {
            user_id:localStorage.getItem("userid"),
            name:this.name,
//            page:4
            page:this.pageIndex
          }
        )
          .then(res=>{
//           this.listData=res.data
            const rows=res.data
            this.isUpLoading =false

            if(rows==null||rows.length===0){
              this.upFinished=true
              return
            }
            if(rows.length<this.pageSize){
              this.upFinished=true
            }
            this.listData = this.listData.concat(rows);
//            if (this.pageIndex === 1) {
//              alert(3)
//              this.listData = rows
//            } else {
//              alert(4)
//              this.listData = this.listData.concat(rows)
//            }

//            console.log(this.listData)
//            this.isDownLoading=true
//            this.isUpLoading =true

          })
          .finally(res=>{
//            this.isDownLoading=false
//            this.isUpLoading =false
          })
      },
      followClick(index,a){
        if(localStorage.getItem("userid")==null) return this.$router.push("/Error404")
        this.$api.follow({
          user_id:localStorage.getItem("userid"),
          follow_user_id:index.userid,
          status:a
        })
          .then(res=>{
            this.getWrite()
          })
      },
      followLiker(index,a){
        if(localStorage.getItem("userid")==null) return this.$router.push("/Error404")
        this.$api.followLike({
          user_id:localStorage.getItem("userid"),
          news_id:index.id,
          status:a
        })
          .then(res=>{
            this.getWrite()
          })
      },
      onDownRefresh(){//下拉刷新

      },
      onLoad(){
            this.pageIndex++
        setTimeout(() => {
            this.getWrite()
        }, 1000);
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">

  .van-search{
   /*margin-top: 3rem;*/
  }
  /**{*/
    /*margin: 0;*/
    /*padding: 0;*/
  /*}*/
  .comment{
    width: 80%;
    margin: auto;
    font-size: 13px;
    background: #EEEEEE;
  }
  .commentZhan{
   float: right;
  }
  ul{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  li{
    width: 32%;
    /*height: 100px;*/
    margin-top: 5px;
  }
  .list:not(:nth-child(3n)) {
    margin-right: 2%;
  }
  ul li:nth-last-child(1):first-child{
                            width: 200px;
                            /*height: 200px;*/
                          }
  ul li:nth-last-child(4):first-child ~ li:nth-child(2n){
    margin-right: 32%;
  }
  ul img{
    width: 100%;
  }
  .word{
    width: 80%;
    margin: auto;
  }
  .write{
    /*display: flex;*/
  }
  .writeImg{
    display: flex;
    width: 80%;
    margin: auto;
  }
  .borderColor{
    color: #6e9bcf;
  }
  .searchDiv{
    width: 100%;
    /*display: flex;*/
    background-color: #6e9bcf;
    color: #fff;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .search{
    width: 90%;
  }
  .searchIcon{
    width: 10%;
    display: flex;
    align-items: center;
    background-color: #6e9bcf;
  }
  .follow{
    width: 100%;
    height: 5rem;
    border-bottom: solid 5px #DEDEDE;
    /*background-color: #EEEEEE;*/
    margin-top: 85px;
    display: flex;
  }
  .company{
   /*display: flex;*/
    margin-left: 1.4rem;
  }
  .imgSrc{
    width: 100%;
    border-radius: 100%;
  }
  .imgDiv{
    width: 3.5rem;
    height: 3.5rem;
    background-color: red;
    border-radius: 100%;
  }
  .photoTop{
    display: flex;
    justify-content:space-between;
    align-items:center;/*所有子项沿行内轴中线对齐*/
    padding: 0.8rem 1rem;
    /*margin-top: 6rem;*/
  }
  .photoTopLeft{
    display: flex;
    align-items: center;
  }
  .photoTopRight span{
    display: block;
  }
  .clickFollow{
    background-color: #639DD5;
    color: #FFFFFF;
    border-radius: 6px;
    font-size: 12px;
    padding: 5px;
  }
  .iconDiv{
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin: auto;
    /*margin-top: 1mre;*/
    margin-top: 1rem;
  }
  /deep/  .van-popover--dark{
    background-color: #6e9bcf;
  }
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue